import { BuildFontString } from "../utils/BuildFontString";
import { enumElementBorderStyle, kIndent } from "../constants";
import { QDivider } from "./QDivider";
import { Globals } from "./Globals";
import { MeasureText } from "../utils/MeasureText.js";
import { AddStaticText2 } from "../utils/AddStaticText2.js";
import { AddWrapText } from "../utils/AddWrapText.js";

export class QPanelDivider extends QDivider {
  constructor() {
    super();
  }

  InitPanelDivider(direction, xPos, yPos, width, height, color, radius) {
    this.fStartY = yPos; // used for post sizing calculation
    if (radius != null) {
      this.SetBorderRadius(radius);
      this.SetBorderStyle(enumElementBorderStyle.roundBorder);
      this.SetBorderThickness(0.5);
    }
    this.PositionElement(xPos, yPos);
    this.SetFillColor(color);
    this.SetBorderColor(color);
    this.SizeElement(width, height);
  }

  AddText(xPos, yPos, text, bold, italic, fontSize, wrap) {
    var color = this.fTextColor ? this.fTextColor : Globals._themeMode.text.header;
    var border = 5;

    var availableWidth = this.GetWidth() - xPos - border;
    var availableHeight = this.GetHeight() - yPos - border;

    var fs = BuildFontString("Verdana", fontSize, bold, italic);

    if (wrap) {
      var maxRows = Math.floor(availableHeight / MeasureText(text, fs));
      var textElem = AddWrapText(
        this,
        xPos,
        yPos,
        availableWidth,
        text,
        bold,
        color,
        "Verdana",
        fontSize,
        maxRows
      );
    } else {
      textElem = AddStaticText2(this, xPos, yPos, text, bold, color, "Verdana", fontSize);
    }

    return textElem;
  }

  GetPadStartY(buffer) {
    return this.fStartY + (buffer ? buffer : 0);
  }

  PostCalcSize(endY, buffer) {
    var bottomBuffer = buffer != null ? buffer : kIndent;
    var newHeight = endY - this.fStartY + bottomBuffer;
    if (newHeight > this.fHeight) this.SetHeight(Math.floor(newHeight));

    return newHeight;
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    var xPos = this.fHorzOffset;
    var yPos = this.fVertOffset;
    ctx.strokeStyle = this.GetBorderColor();
    ctx.fillStyle = this.IsGradientFill() ? this.GetGradient(ctx) : this.GetFillColor();
    if (this.fClippedRegion) {
      ctx.fill(this.fClippedRegion);
      ctx.stroke(this.fClippedRegion);
    } else {
      ctx.fillRect(xPos, yPos, this.fWidth * Globals._dpr, this.fHeight * Globals._dpr);
    }

    ctx.restore();
  }
}
